import React from 'react';
import { FlowContainer, FlowContextType } from '../../../../../services/types/Flow';

const Context = React.createContext<FlowContextType>({
  data: {} as FlowContainer,
  loading: false,
  loader: () => {},
  reload: () => {},
});

export default Context;
